import {
  CSSProperties,
  ChangeEventHandler,
  MouseEventHandler,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';
import styles from './index.module.sass';
import classNames from 'classnames';
import MaskedInput from 'react-text-mask';

export const InputWithSign = ({
  label,
  postfix,
  float,
  max,
  value,
  onChange,
  onFocus,
  className,
  placeholder,
  autogrow,
  onClick,
  prefix,
  mask,
  inputClassName,
  options,
  onOptionSelect,
  onWheel,
  onKeydown,
  onBlur,
  allowZero,
  autoComplete,
  blocker = true,
  style,
}: IInputWithSign) => {
  const mainRef: any = useRef(null);
  const dropdownRef: any = useRef(null);
  const inputRef: any = useRef(null);
  const [dropdownVisible, setDropdownVisble] = useState(false);

  useEffect(() => {
    if (options) {
      const handleClickOutside = (event: any) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setDropdownVisble(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }

    if (onWheel) {
      mainRef.current.addEventListener('wheel', (e: any) => {
        e.preventDefault();
        //onWheel(e);
      });
    }
  }, []);
  return (
    <div
      className={classNames(
        styles.inputWithSign,
        className,
        autogrow && styles.autogrow,
      )}
      onWheel={onWheel}
      onBlur={onBlur}
      onKeyDown={onKeydown}
      ref={mainRef}
      style={style}
    >
      {label && <span className={styles.inputLabel}>{label}</span>}
      <div
        className={classNames(styles.inputBody, inputClassName && inputClassName)}
        onClick={() => inputRef.current?.focus()}
        style={
          dropdownVisible && Array.isArray(options) && options.length > 0
            ? { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }
            : {}
        }
      >
        {prefix && <span className={styles.prefix}>{prefix}</span>}{' '}
        {mask ? (
          <>
            <MaskedInput
              autoComplete={autoComplete}
              ref={inputRef}
              mask={mask}
              guide={true}
              onFocus={() => {
                onFocus && onFocus();
                options && setDropdownVisble(true);
              }}
              value={value}
              onChange={(e) => {
                onChange && onChange(e);
                options && setDropdownVisble(true);
              }}
              type="text"
              min={1}
              max={max || 100000}
              placeholder={placeholder === '' ? '' : placeholder || '0'}
              onClick={onClick}
              style={{ width: Boolean(postfix) ? '85%' : '100%' }}
            />
            {blocker && <div className={styles.blocker} onClick={onClick}></div>}
          </>
        ) : (
          <input
            autoComplete={autoComplete}
            ref={inputRef}
            onFocus={() => {
              onFocus && onFocus();
              options && setDropdownVisble(true);
            }}
            value={allowZero ? value : value === 0 ? '' : value}
            onChange={(e) => {
              onChange && onChange(e);
              options && setDropdownVisble(true);
            }}
            type="text"
            min={1}
            max={max || 100000}
            placeholder={placeholder === '' ? '' : placeholder || '0'}
            onClick={onClick}
            style={{ width: Boolean(postfix) ? '40%' : '100%' }}
          />
        )}
        {postfix && (
          <span
            style={
              postfix.toString().length > 4
                ? { cursor: 'pointer' }
                : { cursor: 'default' }
            }
            title={postfix.toString().length > 4 ? postfix.toString() : undefined}
            className={styles.postfix}
          >
            {postfix}
          </span>
        )}
      </div>
      {options && options?.length > 0 && dropdownVisible && (
        <div className={styles.dropdown} ref={dropdownRef}>
          {options.map((item, i) => (
            <div
              key={i}
              className={styles.optionItem}
              onClick={() => {
                setDropdownVisble(false);
                onOptionSelect && onOptionSelect(item.label);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export interface IInputWithSign {
  label?: string | any;
  postfix: string | ReactNode;
  float?: boolean;
  max?: number | null;
  value: number | string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: any;
  className?: string;
  inputClassName?: string;
  placeholder?: string;
  autogrow?: boolean;
  onClick?: MouseEventHandler<HTMLInputElement>;
  prefix?: string;
  mask?: any;
  options?: { label: string }[];
  onOptionSelect?: (val: string) => void;
  onWheel?: any;
  onBlur?: any;
  onKeydown?: any;
  allowZero?: boolean;
  blocker?: boolean;
  autoComplete?: string;
  style?: CSSProperties;
}
